import {
	PromotionType,
	DayOfWeek,
	ComparisonOperator,
	DepositHistoryPeriod,
} from './type'

export const promotionTypeMapper: Record<PromotionType, string> = {
	[PromotionType.NEW_USER]: 'ผู้ใช้ใหม่ (สมัครภายใน 1 เดือนที่ผ่านมา)',
	[PromotionType.FIRST_DEPOSIT]: 'ฝากเงินครั้งแรก',
	[PromotionType.FIRST_TIME_OF_DAY]: 'ฝากเงินครั้งแรกของวัน',
	[PromotionType.DEPOSIT_AMOUNT]: 'จำนวนเครดิตที่ฝาก',
	[PromotionType.DAY_OF_WEEK]: 'โปรโมชั่นสำหรับวัน',
	[PromotionType.RANK]: 'ระดับ',
	[PromotionType.LOSS_AMOUNT]: 'จำนวนยอดเสีย (เมื่อเล่นแบบไม่ฝากโปร)',
	[PromotionType.TURNOVER]: 'เทิร์นโอเวอร์',
	[PromotionType.DEPOSIT_HISTORY_AMOUNT]: 'ประวัติยอดฝากสะสม',
} as const

export const dayOfWeekMapper: Record<DayOfWeek, string> = {
	[DayOfWeek.MONDAY]: 'วันจันทร์',
	[DayOfWeek.TUESDAY]: 'วันอังคาร',
	[DayOfWeek.WEDNESDAY]: 'วันพุธ',
	[DayOfWeek.THURSDAY]: 'วันพฤหัสบดี',
	[DayOfWeek.FRIDAY]: 'วันศุกร์',
	[DayOfWeek.SATURDAY]: 'วันเสาร์',
	[DayOfWeek.SUNDAY]: 'วันอาทิตย์',
} as const

export const operatorMapper: Record<ComparisonOperator, string> = {
	[ComparisonOperator.GREATER_THAN]: 'มากกว่า',
	[ComparisonOperator.GREATER_THAN_OR_EQUAL]: 'มากกว่าหรือเท่ากับ',
} as const

export const rankMapper = {
	BRONZE: 'บรอนซ์',
	SILVER: 'ซิลเวอร์',
	GOLD: 'โกลด์',
	PLATINUM: 'แพลตตินัม',
	DIAMOND: 'ไดมอนด์',
} as const

export const depositHistoryPeriodMapper: Record<DepositHistoryPeriod, string> =
	{
		[DepositHistoryPeriod.TODAY]: 'วันนี้',
		[DepositHistoryPeriod.MONTH]: 'เดือนนี้',
	} as const
